import { createStorageValue } from '@interhyp/platform-storage';
import { z } from 'zod';
import { portalNamespace } from '../namespaces';
export const toolAreaDrawerValue = createStorageValue({
    namespace: portalNamespace,
    schema: z.string(),
    type: 'local',
    id: Symbol('toolarea-drawer-value'),
});
